import { _decorator, Canvas, Node, Enum, VideoClip } from 'cc';
import { DEV, EDITOR } from 'cc/env';
import DOMElementGenerator, { HTMLElementTagName } from './DOMElementGenerator';

const { ccclass, property } = _decorator;

@ccclass('VideoElementGenerator')
export default class VideoElementGenerator extends DOMElementGenerator {
    @property({
        visible: false,
        formerlySerializedAs: 'elementTagName',
        override: true,
    })
    protected _elementTagName = HTMLElementTagName.video;
    @property
    protected _playOnClickCanvas: boolean = true;
    @property
    protected _loop: boolean = true;
    @property(VideoClip)
    private readonly defaultClip: VideoClip = null;

    protected declare _element: HTMLVideoElement;

    @property({
        visible: false,
        type: Enum(HTMLElementTagName),
        tooltip: DEV && 'The tag name of the element, used when the target element is not found in DOM tree',
        override: true,
    })
    public get elementTagName() {
        return this._elementTagName;
    }
    public set elementTagName(value: HTMLElementTagName) {
        if (this._elementTagName === value) {
            return;
        }
        this._elementTagName = value;
        if (!EDITOR && this._element) {
            // remove old element and create a new one
            this.removeElement();
            this.initElement();
        }
    }
    @property({
        formerlySerializedAs: 'loop',
    })
    public get loop() {
        return this._loop;
    }
    public set loop(value: boolean) {
        if (this._loop === value) {
            return;
        }
        this._loop = value;
        this.element.loop = value;
    }

    public get element() {
        return super.element as HTMLVideoElement;
    }

    protected onLoad() {
        this.initElement();
        this._listenTouchPlay();
    }

    protected applyPropertyOnElement(element: HTMLVideoElement) {
        super.applyPropertyOnElement(element);
        element.crossOrigin = 'anonymous';
        element.setAttribute('crossorigin', 'anonymous');
        element.setAttribute('preload', 'auto');
        element.setAttribute('webkit-playsinline', '');
        element.setAttribute('playsinline', '');
        element.setAttribute('autoplay', '');
        element.loop = this._loop;
        element.muted = true;
        if (this.defaultClip) {
            element.src = this.defaultClip.nativeUrl;
        }
    }

    private _listenTouchPlay() {
        const canvas = this.node.scene.getComponentInChildren(Canvas);
        if (canvas && this._playOnClickCanvas) {
            canvas.node.once(
                Node.EventType.TOUCH_END,
                async () => {
                    this.element.playsInline = true;
                    this.element.setAttribute('webkit-playsinline', '');
                    this.element.setAttribute('playsinline', '');
                    try {
                        await this.element.play();
                    } catch (error) {
                        // ios不承認"滑動"的點擊事件, 因此仍可能出問題, 此時需要再等待正常點擊
                        this._listenTouchPlay();
                    }
                },
                this,
                true,
            );
        }
    }
}
